import { useEffect, useState } from "react";
import { getUserInfo } from "../../api";

const useSeasonId = () => {
  const [seasonId, setSeasonId] = useState<number>();
  useEffect(() => {
    getUserInfo().then((userInfo) => {
      const last = userInfo.seasons[userInfo.seasons.length - 1];
      setSeasonId(last?.id);
    });
  }, []);
  return seasonId;
};

export default useSeasonId;
